import { render, staticRenderFns } from "./settlement-detail.vue?vue&type=template&id=5353d95a"
import script from "./settlement-detail.vue?vue&type=script&lang=js"
export * from "./settlement-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports